import useTreeItemStyles from "./partnerstyledtreeitem.styles";
import PropTypes from "prop-types";
import TreeItem from "@material-ui/lab/TreeItem";
import { Link } from "react-router-dom";
import Typography from "@material-ui/core/Typography";
import clsx from "clsx";

function StyledTreeItem(props) {
  const classes = useTreeItemStyles();
  const {
    labelText,
    labelIcon: LabelIcon,
    labelInfo,
    isBold,
   grandTitre,
   sousTitre,
    label,
    // handleClick,
    color,
    bgColor,
    link,
    params,
    isActiveMenu,
    labelInfoClassName,
    ...other
  } = props;
  function handleClick() {
    localStorage.setItem("module", JSON.stringify({ label }));
  }

  const contentNode = (
    <>
      <LabelIcon color="inherit" className={classes.labelIcon} />
      <Typography variant="body2" className={isBold ? classes.labelTextBold : classes.labelText}>
        {labelText}
      </Typography>
      {labelInfo && (
        <span className={clsx(classes.contentLabel, labelInfoClassName)}>{labelInfo}</span>
      )}
    </>
  );

  return (
    <TreeItem
      label={
        link ? (
          <Link to={link} className={classes.labelRoot} onClick={handleClick}>
            {contentNode}
          </Link>
        ) : (
          <div className={classes.labelRoot} onClick={handleClick}>
            {contentNode}
          </div>
        )
      }
      style={{
        "--tree-view-color": color,
        "--tree-view-bg-color": bgColor,
      }}
      classes={{
        root: classes.root,
        content: classes.content,
        expanded: classes.expanded,
        selected: classes.selected,
        group: classes.group,
        label: classes.label,

      }}
      className={isActiveMenu ? classes.activeMenu : ""}
      {...other}
    />
  );
}

StyledTreeItem.propTypes = {
  bgColor: PropTypes.string,
  color: PropTypes.string,
  labelIcon: PropTypes.elementType,
  labelInfo: PropTypes.node,
  labelInfoClassName: PropTypes.string,
  labelText: PropTypes.string.isRequired,
  link: PropTypes.string,
};
export default StyledTreeItem;
